/**
 * Build-time constant gating the dual-run mirror-write inside the
 * cache's `launchFetch` success path. When `true`, every successful
 * cache fetch also dispatches `auth.setToken(token)` to Redux so any
 * consumer still reading via `store.select.auth.getToken` sees the
 * same token as a cache-aware caller.
 *
 * Hard-coded `true` while the dual-run window is open — both reader
 * paths must stay synchronised. Set to `false` (or delete this
 * constant and its import sites together) once every consumer has
 * migrated to `getAccessToken()`.
 *
 * A handful of consumers don't read the mirrored value directly but still
 * depend on this write existing, because they use the Redux token purely as
 * a reactive trigger/gate that observes rotation rather than the credential
 * itself — deleting the mirror silently breaks them even though they never
 * call `store.select.auth.getToken` for the value:
 * - `ChronicleBulkSyncProvider`'s token-change signal (re-fires the
 *   cache-aware token lookup on every rotation)
 * - `agent-event-bus`'s subscription gate
 * - `GlobalVoiceAssistant`'s subscription gate
 * - `useOverlayEvidenceStream`'s subscription gate
 * - `rust-executor-token-refresh` and `useProjectRustExecutorAttach`'s
 *   `store.subscribe` waits for a token to appear
 * Each of these must move to a cache-atom subscription (or equivalent)
 * before this mirror is deleted, not just before it's read for a value.
 */
export const IS_DUAL_RUN_ACTIVE = true;
